import React, {useEffect, useLayoutEffect} from 'react'
import {Outlet, useLocation, useNavigate} from 'react-router-dom';
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import {useDispatch} from "react-redux";

const Inventory = () => {
    const dispatch= useDispatch()
    const nav = useNavigate()
    const { pathname } = useLocation();

    return <React.Fragment>
        <DashboardLayout>
            <Outlet/>
        </DashboardLayout>

    </React.Fragment>
};

export default Inventory;

